export default __webpack_public_path__ + "static/media/gc.db37ce12.png";